import React from 'react';

import styles from './PageSectionTitle.module.scss';

const PageSectionTitle = ({ text }) => {
  return (
    <h3 className={styles.pageSectionTitle}>
      {text}
    </h3>
  );
};

export default PageSectionTitle;
